module.exports = __webpack_public_path__ + "img/not-found.78da0038.png";